import makeTable from "./makeTable";
import BASE_WIDTH_COLUMNS from "./constants/baseWidthColumns";

const { DATE } = BASE_WIDTH_COLUMNS;

const customersClientsModalFeedback = makeTable({
	allIds: ["date", "feedback", "executor", "rating", "orderNumber"],
	defaultIds: ["date", "feedback", "executor", "rating", "orderNumber"],
	i18tPath: (id) => `tableColumns.customers.clientsModalFeedback.${id}`,
	initialSortMethod: {
		column: "date",
		type: "desc",
	},
	initialWidths: {
		date: DATE,
		feedback: 500,
		executor: 200,
		rating: 120,
		orderNumber: 200,
	},
	initialResizable: {
		date: true,
		feedback: true,
		executor: true,
		rating: true,
		orderNumber: true,
	},
	initialSortable: {
		date: true,
		feedback: true,
		executor: true,
		rating: true,
		orderNumber: true,
	},
});

export default customersClientsModalFeedback;
